import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import {
  fetchPropOverview,
  resetPropOverview,
} from "../../actions/propOverviewAction";
import { withRouter } from "react-router-dom";
import { openModal } from "../../actions/modalAction";
import { Form, Button } from "semantic-ui-react";
import TextInput from "../form/TextInput";
import NumberInput from "../form/NumberInput";
import SelectInput from "../form/SelectInput";
import CloseButton from "../common/CloseButton";
import {
  //composeValidators,
  combineValidators,
  isRequired,
} from "revalidate";

//
const validate = combineValidators({
  city: isRequired("Location"),
});

//#######
const cityO = ["Dwarka", "Gurugram"];

const city = () => {
  return cityO.map((value) => ({
    key: value,
    text: value ? value : " N/A",
    value: value,
    style: { fontSize: "18px" },
  }));
};
//

class PropOverviewEdit extends Component {
  componentDidMount() {
    const { id } = this.props;
    this.props.fetchPropOverview(id);
  }
  componentWillUnmount() {
    this.props.resetPropOverview();
  }
  onSubmit = async (values) => {
    //************
    try {
      const { id } = this.props;
      const res = await axios.put(`/api/PropOverviewEdit/${id}`, values);

      if (res.data.msg === "success") {
        toastr.success("Updated Successfully");
        this.props.handleEditModalCloseSubmit();
      }
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        console.log("error_edit_review", error);
        toastr.error(
          "Oops",
          "Something went wrong.Please Try Again_EditpropOverview"
        );
      }
    }
    //**********
  };

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;

    return (
      <div
        className="card-form border-radius marginBottom min-max-width position-relative"
        style={{ margin: "auto" }}
      >
        <CloseButton closeBtn={this.props.handleEditModalClose} />
        <div>
          <div className="">
            {/**/}

            <div
              style={{
                textAlign: "center",
                fontSize: "1.5rem",
                fontWeight: "bold",
                padding: "15px",
                color: "dodgerblue",
              }}
            >
              {/*  */}
              Edit PropOverview
              {/*  */}
            </div>

            {/**/}
            <div className=" label">
              <Form
                style={{ padding: 20 }}
                onSubmit={handleSubmit(this.onSubmit)}
              >
                <br />
                <div>
                  <span className="color-mandatory">* </span>Mandatory Fields
                </div>
                <label>Location (City)</label>
                <span className="color-mandatory"> * </span>
                <Field
                  name="city"
                  placeholder="Location (City)"
                  type="text"
                  options={city()}
                  //search={true}
                  component={SelectInput}
                />
                <label>Tag</label>
                <Field
                  name="tag"
                  type="text"
                  component={TextInput}
                  placeholder="Sale/Rent/Residential Project/New Launch"
                />
                <label>Heading</label>
                <Field
                  name="heading"
                  type="text"
                  component={TextInput}
                  placeholder="Heading"
                />
                <label>Line1</label>
                <Field
                  name="line1"
                  type="text"
                  component={TextInput}
                  placeholder="overview detail"
                />
                <label>Line2</label>
                <Field
                  name="line2"
                  type="text"
                  component={TextInput}
                  placeholder="overview detail"
                />
                <label>Line3</label>
                <Field
                  name="line3"
                  type="text"
                  component={TextInput}
                  placeholder="overview detail"
                />
                <label>Line4</label>
                <Field
                  name="line4"
                  type="text"
                  component={TextInput}
                  placeholder="overview detail"
                />
                <label>Line5</label>
                <Field
                  name="line5"
                  type="text"
                  component={TextInput}
                  placeholder="overview detail"
                />
                <label>Line6</label>
                <Field
                  name="line6"
                  type="text"
                  component={TextInput}
                  placeholder="overview detail"
                />
                <label>Line7</label>
                <Field
                  name="line7"
                  type="text"
                  component={TextInput}
                  placeholder="overview detail"
                />
                <label>Position</label>
                <Field
                  name="position"
                  type="number"
                  component={NumberInput}
                  placeholder="1/2/3 so on"
                />

                <br />

                <Button
                  color="olive"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  Submit
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>
                <Button
                  color="teal"
                  type="button"
                  onClick={this.props.handleEditModalClose}
                >
                  Cancel
                </Button>

                <br />
              </Form>
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    userA: state.auth.userA,
    propOverviews: state.propOverviews.propOverviews,
    initialValues: state.propOverviews.propOverview,
    propOverview: state.propOverviews.propOverview,
  };
};

export default connect(mapStateToProps, {
  fetchPropOverview,
  resetPropOverview,
  openModal,
})(
  reduxForm({
    form: "PropOverviewEdit", // a unique identifier for this form
    validate,
  })(withRouter(PropOverviewEdit))
);
